var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b-btn',{ref:"theButton",staticClass:"rounded the-button",attrs:{"id":_vm.id,"size":"sm","variant":_vm.variant,"to":_vm.to}},[_c('span',{staticClass:"h4 icon",class:_vm.icon})]),_vm._v(" "),_c('b-tooltip',{attrs:{"placement":"top","target":_vm.id,"title":_vm.tooltip,"container":_vm.id}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8213d292","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IconButton.vue
// module id = null
// module chunks = 